module.exports = __webpack_public_path__ + "img/04.b9e3137d.png";